import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=1c4b689c&scoped=true&"
import script from "./privacyPolicy.vue?vue&type=script&lang=js&"
export * from "./privacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=1c4b689c&lang=scss&scoped=true&"
import style1 from "./privacyPolicy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b689c",
  null
  
)

export default component.exports